import { Vue, Mixins, Component, VModel, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { Debounce } from 'lodash-decorators'
import { initProject } from '@/utils/project'
import Project from '@/views/Project/Project/models/project'
import { Company } from '@/views/Company/types/company'

@Component({
    inheritAttrs: false,
})
export default class ProjectAutocomplete extends Mixins<MixinInterface>() {
    @VModel() projects!: Array<Project> | null | Project
    @Prop({ default: true }) attach!: boolean
    @Prop({ default: false }) canAddNewProject!: boolean
    @Prop({ default: 'project' }) module!: string
    @Prop({ default: 'projects' }) endpoint!: string
    @Prop() filters!: Record<string, any> | null
    @Prop({ type: Boolean }) showOwner!: boolean
    @Prop() resultsFilterFn!: (item: Project) => boolean
    @Prop() company!: Company

    loading = false
    limit = 20
    offset = 0
    searchTerm = ''

    results: Array<Project> = []

    async newProject() {
        const newProject = await initProject(this.company, null, {
            name:
                this.projects &&
                !Array.isArray(this.projects) &&
                this.projects.name === this.searchTerm
                    ? ''
                    : this.searchTerm,
        })
        newProject._id = newProject.id
        this.results.push(newProject)
        this.projects = newProject
    }

    @Watch('searchTerm')
    async searchBySearchTerm() {
        if (
            this.projects &&
            !Array.isArray(this.projects) &&
            this.projects.name === this.searchTerm
        ) {
            return
        }

        this.loading = true

        let filters = {
            ...(this.searchTerm && this.searchTerm.trim().length > 1
                ? {
                      'filter[searchTerm]': this.searchTerm.trim(),
                  }
                : {}),
            ...(this.filters && this.filters),
            'page[offset]': this.offset,
            'page[limit]': this.limit,
        }

        await this.fetchDebounced(filters)

        this.loading = false
    }

    @Debounce(500)
    async fetchDebounced(filters) {
        this.loading = true
        let query = {
            include: this.showOwner ? ['owner'] : [],
            skipLinks: true,
            filters: filters,
        }

        let res = await Vue.prototype.$vbit.get(this.module, this.endpoint, query).catch(() => {
            this.loading = false
        })

        this.results = res.data.map((item) => new Project(item, res.included))

        if (this.resultsFilterFn) this.results = this.results.filter(this.resultsFilterFn)

        this.loading = false
    }

    async mounted() {
        await new Promise((resolve) => setTimeout(resolve, 0))
        if (this.projects && !Array.isArray(this.projects)) {
            await this.fetchDebounced({ 'filter[id]': [this.projects._id] })
        }
    }
}
